import logo from '../logo.svg';
import hostages from '../res/134.svg';
import logoNight from '../logo_night.svg';
import '../App.css';
import { useTranslation } from 'react-i18next';
import Forecast24h from './Forecast24h';
import NextDays from './NextDays';
import Notifications from './Notifications';
import Ad from './Ad';
import Adnimation from './Adnimation';
import { React, useContext, useState } from 'react';
import Statuses from './Statuses';
import PicOfTheDay from './PicOfTheDay';
import UserPics from './UserPics';
import Activities from './Activities';
import AdsInternal from './AdsInternal';
import LatestNow from './LatestNow';
import { GoogleLogin } from "@react-oauth/google";
import {useConfig} from "../helpers/useConfig";
import TempGraph from './TempGraph';
import Btn from './Button';
import ReactModal  from 'react-modal';
import CurrentStory from './CurrentStory';
import ThisMonthClimate from './ThisMonthClimate';
import Lottie from "lottie-react";
import town from "../res/lottie/main_background_town_graphics.json";
import Live from './Live';
import Credit from './Credit';
import SocialAndStore from './SocialAndStore';
import { Alert } from 'bootstrap';

function App3({json, cssClasses, activities_json}) {
  
    const { t, i18n } = useTranslation();
    const [isOpen, setPopupIsOpen] = useState(false);
    const [isConnectContainerOpen, setIsConnectContainerOpen] = useState(false);
    const [currentTitle, setCurrentTitle] = useState(false);
    const {configData, setConfig} = useConfig();
     
    var langcode = configData.lang;
    if (json.length === 0){ 
      return <div>loading...</div>
    }
  
  const setIsOpen = ({isOpen}) => {
        
    setPopupIsOpen(isOpen);
  } 

  function isNight() {
    return cssClasses.includes("night");   
    
  } 
 const saveConfigData = () => {
  configData.layout = "forecast24";
  localStorage.setItem('configData', JSON.stringify(configData));
  console.log ('saved' + JSON.stringify(configData));
 }

  const nextDays = json.jws.forecastDays;
  const nextHours = json.jws.forecastHours;
  const nextSigHours = json.jws.sigforecastHours;
  const ads = json.jws.Ads;
  const desc = json.jws.desc;
  const current = json.jws.current;
  const today = json.jws.today;
  const feelslike = json.jws.feelslike;
  const messages = json.jws.Messages;
  const statuses = json.jws.states.sigweather;  
  const thisMonth = json.jws.thisMonth;
  const states = json.jws.states;
  const yest = json.jws.yest;
  const windstatus = json.jws.windstatus;
  const picoftheday = json.jws.LatestPicOfTheDay;
  const userpics = json.jws.LatestUserPic;
  const currentrecommendations = json.jws.current.recommendations;
  
    var logoToDisplay = isNight() ? logo : logo; 
    return (
      <>
    <div className={"clouds container-fluid App " + cssClasses}>
        <header
          className={"App-header row mb-2 " + (langcode === 1 ? "rtl" : "")}
        >
          <div className="row ">
            <div className="col-12 ">
              <div className="AppHeader">
                <div className="App-logo-container"><a href={`/`}> <img src={logoToDisplay} className="App-logo" alt="logo"/></a></div>
                                 {t("SLOGAN")}{" "}
                                - {t("WEBSITE_TITLE")}<div className="App-date"> {eval(`current.date${langcode}`)} </div>

              </div>
            </div>
          </div>
        </header>
         <div className={"row " + (langcode === 1 ? "rtl" : "")}>
          <div className="col-xs-8 col-lg-8">
            <div className="col mt-12">
              <NextDays
                days={nextDays}
                lang={langcode}
                className={cssClasses}
                yest={yest}
                activities_json={activities_json}
              />
             
            </div>
            <div className="col mt-12">
               <Forecast24h
                cssClasses={cssClasses}
                hours={nextHours}
                sigHours={nextSigHours}
                lang={langcode}
                className={cssClasses}
              />
              <div className="row">
              <div className='col-xs-4 col-lg-4'>
                 {ads.length > 0 && <AdsInternal ads={ads} location="other"/>}
                 {ads.length == 0 && <Ad width={300} height={200} format="auto" slot="1064121490"/>}
              </div>
              <div className="col-xs-8 col-lg-8">
                <Ad width={600} height={100} format="auto" slot="7748861760" />
              </div>
              
              </div>
              <div className="row">
                <ThisMonthClimate desc={desc} ThisMonth={thisMonth} lang={langcode} ads={ads}/>
              </div>
              
            </div>
          </div>
           <div className="col-xs-4 col-lg-4">
            <Notifications
              notifications={messages}
              ads={ads}
              lang={langcode}
              className={cssClasses}
            />
            <Ad width={300} height={200} format="auto" slot="1816548745"/>
            <CurrentStory lang={langcode} />
            <Adnimation width={300} height={300} format="" />
           
          </div>
        <div className={"row " + (langcode === 1 ? "rtl" : "")}>
           <div className="col-xs-4 col-md-6 col-lg-4  ">
            <LatestNow
              current={current}
              today={today}
              feelslike={feelslike}
              windstatus={windstatus}
              lang={langcode}
              cssClasses={cssClasses}
            />
          </div>
          <div className="col-xs-4 col-md-6 col-lg-4  ">
            <Statuses
              statuses={statuses}
              lang={langcode}
              className={cssClasses}
            />
            <Activities
              activities_json={activities_json}
              activities={currentrecommendations}
              lang={langcode}
            />
          </div>
          <div className="col-xs-4 col-md-12 col-lg-4 ">
            <Adnimation width={300} height={300} format="fluid" />
          </div>
        </div>

       
         
        </div>
   
        <div className="row">
          <div className="col-xs-4 col-lg-4 ">
            <div className="white_transp_box white_box ">
              
            </div>
          </div>
          <div className="col-xs-4 col-lg-4 ">
            <PicOfTheDay pic={picoftheday} lang={langcode} />         
          </div>
          <div className="col-xs-4 col-lg-4 ">
            <Live lang={langcode} />
          </div>
        </div>
        <div className="white_transp_box white_box">
          
             <UserPics userPics={userpics} lang={langcode} />
         
        </div>
         <div className={" row "}>
          <SocialAndStore animationData={town} loop={true} 
              />
        </div>
        <div className={"city row "}>
          <Lottie animationData={town} loop={true} 
              />
       </div>
       <div className={"row "}>
          <Credit 
              lang={langcode}
              cssClasses={cssClasses}/>
       </div>
       </div>
       
      
        
      <ReactModal
        isOpen={isOpen}
        contentLabel="Example Modal"
        onRequestClose={() => setIsOpen(false)}
      >
        <Btn
          btnOnClick={() => setIsOpen(false)}
          btnTitleText={""}
          img={"X"}
          cssClasses="float-start"
        ></Btn>
        {currentTitle}

        <br />
        <br />
        <br />
        <Btn btnOnClick={() => setIsOpen(false)} btnTitleText={"Ok"}></Btn>
      </ReactModal>
    </>

    );
  
}

export default App3;
